<div class="row headband">
  <div matTooltip="{{ 'COPY_RECIPES_MARKET.TOOLTIP_DISABLED' | translate }}" [matTooltipDisabled]="!isButtonDisabled()">
    <button
      id="RecipesSearchCopyMarketBtn"
      [disabled]="!queryForm.controls.domain.value || !queryForm.controls.market.value || !queryForm.controls.lang.value"
      (click)="copyByMarket()"
      mat-raised-button
      color="primary"
      class="btn-acp"
    >
      {{ 'COPY_RECIPES_MARKET.BTN' | translate }}
    </button>
  </div>
</div>
